import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { withComponentPreview } from '@wix/editor-elements-preview-utils';
import React from 'react';
import { FacebookShareProps } from '../FacebookShare.types';

export default (ViewerComponent: React.ComponentType<FacebookShareProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent as any));
